(function () {
  var sections = document.querySelectorAll('.product-bundle');
  if (!sections.length) return;

  sections.forEach(function (section) { initBundleSection(section); });

  function initBundleSection(section) {

  if (section.dataset.bundleInitialized === '1') return;
  section.dataset.bundleInitialized = '1';

  var cards = section.querySelectorAll('product-item.product-item--bundle');
  var addBtn = section.querySelector('[data-bundle-add]');
  var savingsText = section.querySelector('[data-bundle-savings-text]');
  var errorEl = section.querySelector('[data-bundle-error]');
  var discountType = section.dataset.discountType || 'percentage';
  var discountValue = parseFloat(section.dataset.discountValue) || 0;
  var ctaTextEl = addBtn ? addBtn.querySelector('.product-bundle__cta-text') : null;
  var ctaOriginalText = ctaTextEl ? ctaTextEl.textContent.trim() : '';

  // When exclude_active_product is set, the PDP's selected variant must be added to the cart alongside
  // the bundle cards — otherwise the app's cart-transform function won't find all required products and
  // will skip the merge, causing the bundle discount to silently not apply.
  //
  // The single source of truth is the live PDP form: <form id="product-form-main-…"> carries the
  // selected variant in input[name="id"], and the variant-picker's <script data-variant> carries its
  // price. We resolve these ON DEMAND rather than caching, because a combined-listing color switch
  // REPLACES the product form with the sibling product's form (new product id, and crucially NO
  // variant:change event fires) — a cached node or seed would go stale and add the color that happened
  // to load first instead of the one the shopper selected.
  var excludedProductId = section.dataset.excludeActiveProductId;
  var activeVariant = null;

  function resolveActiveVariant() {
    if (!excludedProductId) return null;
    var scope = document.querySelector('product-rerender[id^="product-info-"]') || document;
    var idInput = scope.querySelector('form[id^="product-form-main-"] input[name="id"]');
    var id = idInput && idInput.value ? parseInt(idInput.value, 10) : 0;
    if (!id) {
      // Theme editor / unusual layouts where the form lookup fails: fall back to the server seed.
      var seedId = parseInt(section.dataset.activeVariantId || '0', 10);
      return seedId ? { id: seedId, price: parseInt(section.dataset.activeProductPrice || '0', 10) } : null;
    }
    var price = 0;
    var variantJson = scope.querySelector('script[data-variant]');
    if (variantJson) {
      try { price = JSON.parse(variantJson.textContent || '{}').price || 0; } catch (e) {}
    }
    if (!price) price = parseInt(section.dataset.activeProductPrice || '0', 10);
    return { id: id, price: price };
  }

  if (excludedProductId) {
    activeVariant = resolveActiveVariant();
    // Keep the savings display in sync as the shopper swaps the PDP variant. Size changes emit
    // variant:change; combined-listing color swaps re-render the product form and emit a popstate.
    var refreshActive = function () { activeVariant = resolveActiveVariant(); updateSavings(); };
    document.addEventListener('variant:change', refreshActive);
    window.addEventListener('popstate', refreshActive);
  }

  var t = {
    selectSizeError: section.dataset.tSelectSizeError || 'Please select a size for all products',
    adding: section.dataset.tAdding || 'Adding...',
    added: section.dataset.tAdded || 'Added!',
    error: section.dataset.tError || 'Something went wrong. Please try again.',
    save: section.dataset.tSave || 'Save __AMOUNT__',
  };

  // Parse featured colors map and normalize GID keys to numeric IDs
  var featuredColors = {};
  try {
    var raw = JSON.parse(section.dataset.featuredColors || '{}');
    Object.keys(raw).forEach(function (key) {
      var numericId = key.indexOf('/') !== -1 ? key.split('/').pop() : key;
      featuredColors[numericId] = raw[key];
    });
  } catch (e) {}

  cards.forEach(function (card) {
    var sizeSelect = card.querySelector('.bundle-card__size-select');
    var productId = card.dataset.productId;

    // Combined-listing bundle slot: swatches are keyed by child product handle,
    // not variant id — requires a separate init path.
    if (card.dataset.combinedBundle === '1') {
      var combined = {};
      try { combined = JSON.parse(card.dataset.combinedChildren || '{}'); } catch (e) {}

      // Swap the card's main image(s) to a child's image. Mirrors theme.js
      // _applyCombinedSibling, which is intentionally disabled on bundle cards.
      var swapCardImage = function (child) {
        if (!child || !child.image) return;
        card.querySelectorAll('.product-item__primary-image:not(.product-item__swatch-image)').forEach(function (img) {
          img.removeAttribute('srcset');
          img.src = child.image;
          if (child.image_id != null) img.setAttribute('data-media-id', String(child.image_id));
          if (child.image_alt != null) img.setAttribute('alt', child.image_alt);
          img.removeAttribute('hidden');
        });
      };

      // Apply a child color: set the selected variant/price from its first
      // AVAILABLE variant (works with OR without a size <select> — single-variant
      // children have no select), rebuild the size options when present, and
      // swap the card image.
      var applyChild = function (child) {
        if (!child || !child.variants) return;
        var first = child.variants.find(function (v) { return v.available; }) || child.variants[0];
        if (sizeSelect) {
          sizeSelect.innerHTML = '';
          child.variants.forEach(function (v) {
            var opt = document.createElement('option');
            opt.value = v.id;
            opt.textContent = v.size + (v.available ? '' : ' - Sold out');
            opt.disabled = !v.available;
            opt.dataset.price = v.price;
            sizeSelect.appendChild(opt);
          });
          if (first) sizeSelect.value = first.id;
        }
        if (first) {
          card.dataset.selectedVariant = String(first.id);
          card.dataset.selectedPrice = String(first.price);
        } else {
          card.dataset.selectedVariant = '';
          card.dataset.selectedPrice = '0';
        }
        swapCardImage(child);
      };

      // Bind combined swatch inputs (keyed by data-product-handle, no data-variant-id)
      var combinedSwatchInputs = card.querySelectorAll('input[data-product-handle]');
      combinedSwatchInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          var child = combined[this.dataset.productHandle];
          if (!child) return;
          card.dataset.selectedChildHandle = this.dataset.productHandle;
          applyChild(child);
          updateSavings();
        });
      });

      // Size select change (multi-size children): update the selected variant.
      if (sizeSelect) {
        sizeSelect.addEventListener('change', function () {
          var selectedOption = this.options[this.selectedIndex];
          card.dataset.selectedVariant = this.value;
          card.dataset.selectedPrice = selectedOption ? (selectedOption.dataset.price || '0') : '0';
          updateSavings();
        });
      }

      // Init: apply the default child so first paint shows that color's image + variant.
      var defaultHandle = card.dataset.defaultChildHandle;
      if (defaultHandle && combined[defaultHandle]) {
        var defaultInput = card.querySelector('input[data-product-handle="' + defaultHandle + '"]');
        if (defaultInput) defaultInput.checked = true;
        card.dataset.selectedChildHandle = defaultHandle;
        applyChild(combined[defaultHandle]);
      }

      updateSavings();
      return; // skip non-combined path below
    }

    // ---- Non-combined bundle slot (original path) ----
    var variants = JSON.parse(card.dataset.productVariants || '[]');
    var colorOptionPos = card.dataset.colorOption;
    var sizeOptionPos = card.dataset.sizeOption;
    var swatchInputs = card.querySelectorAll('input[data-variant-id]');

    // When a color swatch radio is clicked, update selected variant + rebuild size options
    swatchInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var variantId = this.dataset.variantId;
        if (!variantId) return;

        // Find the variant to get its color
        var selectedVariant = variants.find(function (v) { return String(v.id) === variantId; });
        var selectedColor = selectedVariant ? selectedVariant.color : null;

        // If no size selector, just set the selected variant directly
        if (!sizeSelect || !sizeOptionPos) {
          card.dataset.selectedVariant = variantId;
          card.dataset.selectedPrice = selectedVariant ? selectedVariant.price : '0';
          updateSavings();
          return;
        }

        // Rebuild size dropdown for this color
        if (selectedColor && colorOptionPos) {
          var sizeKey = 'option' + sizeOptionPos;
          var placeholder = sizeSelect.options[0] ? sizeSelect.options[0].textContent : 'SELECT SIZE';

          sizeSelect.innerHTML = '';
          var placeholderOpt = document.createElement('option');
          placeholderOpt.value = '';
          placeholderOpt.disabled = true;
          placeholderOpt.selected = true;
          placeholderOpt.textContent = placeholder;
          sizeSelect.appendChild(placeholderOpt);

          variants.forEach(function (v) {
            if (v.color === selectedColor) {
              var opt = document.createElement('option');
              opt.value = v.id;
              opt.textContent = v[sizeKey] + (v.available ? '' : ' - Sold out');
              opt.disabled = !v.available;
              opt.dataset.price = v.price;
              sizeSelect.appendChild(opt);
            }
          });

          // Reset selected variant until size is picked
          card.dataset.selectedVariant = '';
          card.dataset.selectedPrice = '0';
        }

        updateSavings();
      });
    });

    // Size select change
    if (sizeSelect) {
      sizeSelect.addEventListener('change', function () {
        var selectedOption = this.options[this.selectedIndex];
        card.dataset.selectedVariant = this.value;
        card.dataset.selectedPrice = selectedOption ? (selectedOption.dataset.price || '0') : '0';
        updateSavings();
      });
    }

    // Featured color: pre-select swatch and rebuild size on init
    var featuredColor = productId ? featuredColors[productId] : null;
    if (featuredColor && colorOptionPos) {
      var targetColor = featuredColor.toLowerCase();
      var swatchInputs = card.querySelectorAll('input[data-variant-id]');
      for (var i = 0; i < swatchInputs.length; i++) {
        var input = swatchInputs[i];
        var vid = input.dataset.variantId;
        var matchingVariant = variants.find(function (v) { return String(v.id) === vid; });
        if (matchingVariant && matchingVariant.color === targetColor) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    }

    // Sync initial selected variant from size dropdown (if it has a pre-selected value)
    if (sizeSelect && sizeSelect.value) {
      card.dataset.selectedVariant = sizeSelect.value;
      var selOpt = sizeSelect.options[sizeSelect.selectedIndex];
      if (selOpt) card.dataset.selectedPrice = selOpt.dataset.price || '0';
    }
  });

  function updateSavings() {
    var total = 0;
    cards.forEach(function (card) {
      var price = parseInt(card.dataset.selectedPrice || '0', 10);
      if (price > 0) {
        total += price;
      } else if (card.dataset.combinedBundle === '1') {
        // Combined slot with no size chosen yet — fall back to default child's first variant price
        var defaultHandle = card.dataset.defaultChildHandle;
        if (defaultHandle) {
          var combinedData = {};
          try { combinedData = JSON.parse(card.dataset.combinedChildren || '{}'); } catch (e) {}
          var defaultChild = combinedData[defaultHandle];
          if (defaultChild && defaultChild.variants && defaultChild.variants.length > 0) {
            total += defaultChild.variants[0].price;
          }
        }
      } else {
        var variants = JSON.parse(card.dataset.productVariants || '[]');
        if (variants.length > 0) total += variants[0].price;
      }
    });
    if (activeVariant && activeVariant.price) total += activeVariant.price;

    var savings = 0;
    if (discountType === 'percentage') {
      savings = Math.round(total * discountValue / 100);
    } else {
      savings = discountValue * 100;
    }

    if (savingsText && savings > 0) {
      savingsText.textContent = t.save.replace('__AMOUNT__', formatMoney(savings));
    }
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      errorEl.hidden = true;

      var items = [];
      var missing = [];

      cards.forEach(function (card) {
        var variantId = card.dataset.selectedVariant;
        var sizeSelect = card.querySelector('.bundle-card__size-select');

        // If there's a size selector, the variant must come from it
        if (sizeSelect) {
          variantId = sizeSelect.value;
        }

        if (!variantId || variantId === '') {
          missing.push(card.dataset.productHandle || 'unknown');
        } else {
          items.push({ id: parseInt(variantId, 10), quantity: 1, properties: {} });
        }
      });

      if (missing.length > 0) {
        errorEl.textContent = t.selectSizeError;
        errorEl.hidden = false;
        var firstMissing = section.querySelector('product-item.product-item--bundle .bundle-card__size-select');
        if (firstMissing) firstMissing.focus();
        return;
      }

      // Prepend the PDP's currently-selected variant when the active product was excluded from the
      // cards. Resolve it FRESH at click time so a no-reload size/color change — including a
      // combined-listing sibling swap, which never fires variant:change — is honored, rather than
      // adding whichever variant was loaded first.
      var active = resolveActiveVariant();
      if (active && active.id) {
        items.unshift({ id: active.id, quantity: 1, properties: {} });
      }

      // DETERMINISTIC group id = bundle key + the exact variant set. Re-adding the SAME bundle
      // (same selections) reuses this id, so Shopify combines the lines and the cart-transform
      // merges them into ONE line whose quantity is the number of bundles — instead of the old
      // random-per-click id, which made duplicates collapse into a single mislabeled "1x" line.
      // A different variant selection produces a different key, so it stays a separate line.
      var bundleKey = section.dataset.bundleKey || section.dataset.bundleName || 'bundle';
      var sortedIds = items.map(function (it) { return it.id; }).sort(function (a, b) { return a - b; });
      var bundleGroupId = bundleKey + '-' + sortedIds.join('-');
      items.forEach(function (it) { it.properties._bundle_id = bundleGroupId; });

      addBtn.disabled = true;
      if (ctaTextEl) ctaTextEl.textContent = t.adding;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error(t.error);
          return res.json();
        })
        .then(function () {
          if (ctaTextEl) ctaTextEl.textContent = t.added;

          fetch(window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl ? window.themeVariables.routes.cartUrl + '.js' : '/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cartContent) {
              document.documentElement.dispatchEvent(
                new CustomEvent('cart:refresh', {
                  bubbles: true,
                  detail: { cart: cartContent, openMiniCart: true },
                })
              );
            })
            .catch(function () {
              document.documentElement.dispatchEvent(
                new CustomEvent('cart:refresh', { bubbles: true })
              );
            });

          setTimeout(function () {
            addBtn.disabled = false;
            if (ctaTextEl) ctaTextEl.textContent = ctaOriginalText;
          }, 2000);
        })
        .catch(function (err) {
          errorEl.textContent = err.message || t.error;
          errorEl.hidden = false;
          addBtn.disabled = false;
          if (ctaTextEl) ctaTextEl.textContent = ctaOriginalText;
        });
    });
  }

  updateSavings();
  } // end initBundleSection
})();
